import { EtaLocation } from '@/feature/eta'

import { CircleAvatar } from '@/lib/core/components/CircleAvatar'

import styles from '../Eta.module.css'

export const AssetLocationFrom = ({ etaLocation }: { etaLocation: EtaLocation }) => (
  <div className={styles.locationFrom}>
    <div className={styles.locationFromTitle}>Asset ID</div>
    <div className={styles.locationFromContent}>
      <div className={styles.locationFromContentTitle}>
        <CircleAvatar src={etaLocation.avatar} size={28} withBorder />
        {etaLocation.title}
      </div>
    </div>
  </div>
)
